
import { useContext, useEffect, useState } from 'react';
import KhAlert from '../../../Components/Alert/KhAlert';
import { UserInfokh } from '../../../Contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ApiURL } from '../../../App';

const EditEmployee = () => {

    const queryParameters = new URLSearchParams(window.location.search);  // to get employeeId form url
    const employeeId = queryParameters.get("Id"); 
    
    const userInfo_Now =useContext(UserInfokh);
    const [loading,setloadnig]=useState(true);
    const [alert_,SetAlert]=useState({Activate:false,msg:''});
    const [flag,Setflag]=useState(false);
    const navigate =useNavigate();
    const [formData, setFormData] = useState({
          id:0,
          workshopName: '',
          normHWageM: 0,
          normHWageG:0,
          additionalWorkingHourWage:0,
          date: '',
          notes: ''
      });

      useEffect(()=>{

        const fetchData = async () => {
            setloadnig(true);
            try {
            const res=  await axios.get(ApiURL+'Employee/GetEmployee_ByEmployeeId?employeeId='+employeeId,{   
              headers:{
                'Accept': 'text/plain',
                'Content-Type': 'application/json',
                'Authorization': `bearer ${userInfo_Now.auth.token}`
              }
              });
             
             const date = new Date(res.data.date);
              const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
              const formattedDate = localDate.toISOString().split('T')[0];
              res.data.date=formattedDate;
              setFormData(res.data);
              setloadnig(false);                  
              }
              catch(err)
              {
                SetAlert({Activate:true,msg:'تأكد من الاتصال بالانترنت'});
                setloadnig(false);               
              }
          
          };
         
            fetchData();
          
        },[]);

   
      const handleChange = (name, value) => {
        setFormData({
          ...formData,
          [name]: value
        });        
      };

      const handleSubmit = async (e) => {
        Setflag(true);
        if(!(formData.date.length<1 ||formData.workshopName.length<1||formData.normHWageM.length<1
          ||formData.normHWageG.length<1||formData.additionalWorkingHourWage.length<1
        ))
        {
          try {
          const res = await axios.put(ApiURL+'Employee/EditEmpolyee', formData, {
            headers: {
              'Accept': 'text/plain',
              'Content-Type': 'application/json',
               'Authorization': `bearer ${userInfo_Now.auth.token}`
            }
           
          });
          navigate('/AllEmployees');
          navigate(0)
          
        } catch (error) {      
          SetAlert({Activate:true,msg:'تأكد من الاتصال بالانترنت'});
         
        }
        }
      };

    return (
        <>
         <KhAlert Kh_Active={alert_.Activate} msg={alert_.msg} func_setactive={SetAlert} />
            <div className='parent-Dmaterial'>
                <div className='child-Dmaterial'>
                <div className="mb-3"> 
              <label className="form-label">
              اسم الورشة 
              </label>
              <input
                className="form-control"
                type='text'
                name="workshopName"
                value={formData.workshopName}
                onChange={(e)=>{handleChange('workshopName',e.target.value)}}
							/>
              {formData.workshopName.length<2 &&flag&& ( <p className="validationReg"> *الرجاء إدخال اسم الورشة  </p>)}
            </div>
            <div className="mb-3"> 
              <label className="form-label">
              أجار الساعة للشباب 
              </label>
              <input
                className="form-control"
                type="number"
                name="normHWageM"
                value={formData.normHWageM}
                onChange={(e)=>{handleChange('normHWageM',e.target.value)}}
							/>
               {formData.normHWageM.length<1 &&flag&& ( <p className="validationReg"> *الرجاء إدخال قيمة هنا   </p>)}
               </div>
           
            <div className="mb-3"> 
              <label className="form-label">
              أجار الساعة للبنات
              </label>
              <input
                className="form-control"
                type="number"
                name="normHWageG"
                value={formData.normHWageG}
                onChange={(e)=>{handleChange('normHWageG',e.target.value)}}
							/>
             {formData.normHWageG.length<1 &&flag&& ( <p className="validationReg"> *الرجاء إدخال قيمة هنا   </p>)}
            </div>
                
            <div className="mb-3"> 
              <label className="form-label">
             أجار ساعة العمل الإضافي
              </label>
              <input
                className="form-control"
                type="number"
                name="additionalWorkingHourWage"
                value={formData.additionalWorkingHourWage}
                onChange={(e)=>{handleChange('additionalWorkingHourWage',e.target.value)}}
							/>
             {formData.additionalWorkingHourWage.length<1 &&flag&& ( <p className="validationReg"> *الرجاء إدخال قيمة هنا   </p>)}
            </div>
           
            <div className="mb-3">
              <label className="form-label">
                التاريخ
              </label>
              <input
                className="form-control"
                type="date"
                name="date"
                value={formData.date}
                onChange={(e)=>{handleChange('date',e.target.value)}}
              />
               {formData.date.length<1 &&flag&& ( <p className="validationReg"> *الرجاء تحديد التاريخ</p>)}
            </div>
            <div className="mb-3">
                <label className="form-label">
                ملاحظات
                </label>
                <textarea 
                type='text'
                className="form-control"
                name="notes" 
                value={formData.notes} 
                onChange={(e)=>{handleChange('notes',e.target.value)}}
                placeholder={"إضافة ملاحظات..."}               
                />
              
            </div>
       
        <button className='btn-Add' onClick={()=>{handleSubmit()}} >تعديل</button>
                </div>
            </div>
            
        </>
    );
}

export default EditEmployee;
